module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }